import { render, staticRenderFns } from "./GeographicalDistributionInfo.vue?vue&type=template&id=4607b565&"
import script from "./GeographicalDistributionInfo.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports